import React from "react";  
import FileIcon from "./FileIcon"; // Ensure this component can handle different file types  
import FileActions from "./FileActions";   
import { FileItem } from "../../types/file";  

interface FileGridViewProps {  
  files: FileItem[];  
  copiedLinkId: string | null;  
  onCopyLink: (id: string, url: string) => void;  
  onDelete: any;  
}  

const formatFileSize = (bytes: any) => {  
  if (bytes === 0) return '0 Bytes';  
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];  
  const i = Math.floor(Math.log(bytes) / Math.log(1024));  
  return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];  
};  

const FileGridView = ({ files, copiedLinkId, onCopyLink, onDelete }: FileGridViewProps) => {  
  return (  
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">  
      {files.map((file) => (  
        <div  
          key={file.id}  
          className="border rounded-lg overflow-hidden transition-all hover:shadow-md bg-white transform hover:scale-105"  
        >  
          <div className="h-32 bg-gray-100 flex items-center justify-center">  
            <FileIcon type={file.type} size="lg" />  
          </div>  
          <div className="p-3">  
            <div className="flex justify-between items-start">  
              <div className="flex-1">  
                <h3 className="font-medium text-sm truncate" title={file.name}>  
                  {file.name}  
                </h3>  
                <p className="text-xs text-gray-500">  
                {!isNaN(Number(file?.size)) ? formatFileSize(Number(file.size)) : file?.size}   • {new Date(file?.uploadDate).toLocaleDateString()}  
                </p>  
              </div>  
              <FileActions   
                fileId={file.id}  
                fileUrl={file.url}  
                fileName={file.name}  
                onDelete={onDelete}  
                copiedLinkId={copiedLinkId}  
                onCopyLink={onCopyLink}  
                variant="dropdown"  
                className="ml-2" // Add margin to separate from the text  
              />  
            </div>  
          </div>  
        </div>  
      ))}  
    </div>  
  );  
};  

export default FileGridView;  